export enum Role {
    Admin = 1,
    SuperUser = 2,
    OrganisationAdmin = 3,
    Presenter = 4,
    Participant = 5
}